import { VerificationMethod } from "@/src/components/cards/components/ProductCard/components/ProductCardFooter/components/TokenTransferModule/TokenTransferModal/components/steps/VerifyAccount/SecurePhoneNumber/contexts/MFAContextProvider/types";
import axiosWithCredentials, {
  API_BASE_URL,
  makePostAxiosCallWithCookies,
} from "../commons";

export type PhoneNumber = string;

export type PhoneNumberObject = {
  phoneNumber: string;
  countryCallingCode: string;
  countryCode: string;
};

export type VerificationCode = {
  verificationCode: string;
};
export type MfaId = {
  mfaId: string;
};

export const requestForVerificationCode = async (
  verificationMethod: VerificationMethod,
) => {
  // the mfa endpoint now uses the phone number from the user's IDN profile for sms mfa.
  // so phone number is no longer required in the MFA post payload
  // https://github.com/nike-nvs/nvs-code/pull/4610
  return await makePostAxiosCallWithCookies(
    `${API_BASE_URL}/users/current/mfa`,
    {
      type: verificationMethod,
    },
  ).then((data) => {
    return data.mfaId;
  });
};

export const postVerificationCode = async (data: VerificationCode & MfaId) => {
  const { verificationCode, mfaId } = data;
  return await axiosWithCredentials.put(`${API_BASE_URL}/users/current/mfa`, {
    code: verificationCode,
    mfaId: mfaId,
  });
};
